import { render, staticRenderFns } from "./GestioneAttivitaAttivitaDettaglioPage.vue?vue&type=template&id=4459bc1c"
import script from "./GestioneAttivitaAttivitaDettaglioPage.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaAttivitaDettaglioPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports